var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import cep from 'cep-promise';
import { AllCountries, AllStates } from '@/shared/utils/helpers';
import { deburr, isEmpty } from 'lodash';
import { NotificationService } from '@/services/NotificationService';
import { createAccount } from '@/clients/admin';
import Modal from 'components/Modal.vue';
import Input from 'components/Input.vue';
let TestAccountFormContainer = class TestAccountFormContainer extends Vue {
    constructor() {
        super(...arguments);
        this.infoCep = {
            cep: '',
            city: '',
            neighborhood: '',
            state: '',
            street: '',
        };
        this.data = {
            name: '',
            email: '',
            password: '',
            password_confirmation: '',
            phone_number: '',
            street_address: '',
            complemental_address: '',
            neighborhood: '',
            city: '',
            state: '',
            country: 'Brasil',
            zipcode: '',
            house_number: '',
            role: 2,
            credits: 10,
            contractor_document: '',
        };
        this.create_superlogica_account = false;
        this.stateOptions = AllStates();
        this.countryOptions = AllCountries();
        this.rolesOptions = [
            {
                label: 'Owner',
                value: 2,
            },
            {
                label: 'Customer Success',
                value: 6,
            },
            {
                label: 'Free Account',
                value: 7,
            },
        ];
    }
    onInfoCepChange(currVal, oldVal) {
        if (!isEmpty(currVal)) {
            this.data.city = currVal.city;
            this.data.neighborhood = currVal.neighborhood;
            this.data.state = this.searchState(currVal.state);
            this.data.street_address = currVal.street;
        }
    }
    onShowModalChange(currVal, oldVal) {
        if (currVal)
            this.resetAll();
    }
    async registerAccount() {
        const validation = await this.validForm();
        if (!validation) {
            NotificationService.warning('Alerta', 'Preencha todos os campos obrigatórios');
            return;
        }
        try {
            await createAccount({
                email: this.data.email,
                name: this.data.name,
                password: this.data.password,
                role: this.data.role,
                phone_number: this.data.phone_number,
                contractor_document: this.data.contractor_document,
                zipcode: this.data.zipcode,
                neighborhood: this.data.neighborhood,
                house_number: this.data.house_number,
                city: this.data.city,
                street_address: this.data.street_address,
                state: this.data.state,
                country: this.data.country,
                complemental_address: this.data.complemental_address,
                credits: this.data.role === 7 ? this.data.credits : undefined,
                create_superlogica_account: this.create_superlogica_account,
            });
            NotificationService.success('Sucesso', 'Usuário cadastrado com sucesso');
        }
        catch (e) {
            console.log(e);
        }
    }
    validForm() {
        // @ts-ignore TS2349: property inexistent
        return this.$refs.formAccountTest.validate().then(success => success);
    }
    resetValidationForm() {
        setTimeout(() => {
            // @ts-ignore TS2349: property inexistent
            this.$refs.formAccountTest.resetValidation();
        }, 300);
    }
    countryFilter(val, update) {
        if (val === '') {
            update(() => {
                this.countryOptions = AllCountries();
            });
            return;
        }
        update(() => {
            const needle = deburr(val.toLowerCase());
            this.countryOptions = AllCountries().filter(v => deburr(v.toLowerCase()).indexOf(needle) > -1);
        });
    }
    checkingEmail(value) {
        const start = value.indexOf('@') > -1;
        const end = value.indexOf('.com') > -1;
        if (start && end) {
            return true;
        }
        else {
            return false;
        }
    }
    async searchZip() {
        if (this.data.zipcode.length !== 8)
            return;
        try {
            const result = await cep(this.data.zipcode);
            if (!result.city) {
                NotificationService.error('Erro', 'CEP não encontrado');
            }
            else {
                this.infoCep = result;
            }
        }
        catch (e) {
            NotificationService.error('Erro', 'CEP não encontrado');
        }
    }
    resetValues() {
        this.data = {
            name: '',
            email: '',
            password: '',
            password_confirmation: '',
            phone_number: '',
            street_address: '',
            complemental_address: '',
            neighborhood: '',
            city: '',
            state: '',
            country: 'Brasil',
            zipcode: '',
            role: 2,
            credits: 10,
            contractor_document: '',
            house_number: '',
        };
    }
    resetAll() {
        this.resetValues();
        this.resetValidationForm();
    }
    searchState(value) {
        if (!isEmpty(value)) {
            const stateFound = this.stateOptions.find(option => option.value === value);
            if (stateFound !== undefined) {
                return stateFound.value;
            }
            else {
                return '';
            }
        }
    }
    requiredOnlyWhenCreateSuperlogicaAccount(val) {
        if (!this.create_superlogica_account)
            return true;
        return !!val || 'Campo é obrigatório';
    }
};
__decorate([
    PropSync('open', { default: false })
], TestAccountFormContainer.prototype, "showModal", void 0);
__decorate([
    Watch('infoCep')
], TestAccountFormContainer.prototype, "onInfoCepChange", null);
__decorate([
    Watch('showModal')
], TestAccountFormContainer.prototype, "onShowModalChange", null);
TestAccountFormContainer = __decorate([
    Component({
        name: 'TestAccountFormContainer',
        components: { Modal, Input },
    })
], TestAccountFormContainer);
export default TestAccountFormContainer;
